import {
  GET_CARS_START,
  GET_CARS_SUCCESS,
  GET_CARS_FAIL,
  GET_CAR_START,
  GET_CAR_SUCCESS,
  GET_CAR_FAIL,
} from '../constants';

export const initialState = {
  cars: null,
  car: null,
  fetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CARS_START:
      return {
        ...state,
        fetching: true,
      };
    case GET_CARS_SUCCESS:
      return {
        ...state,
        fetching: false,
        cars: action.payload,
      };
    case GET_CARS_FAIL:
      return {
        ...state,
        fetching: false,
      };
    case GET_CAR_START:
      return {
        ...state,
        fetching: true,
      };
    case GET_CAR_SUCCESS:
      return {
        ...state,
        fetching: false,
        car: action.payload,
      };
    case GET_CAR_FAIL:
      return {
        ...state,
        fetching: false,
      };
    default:
      return state;
  }
};
